import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

import { SubmitEmployeeDetails, deleteEmployeeDetails, fetchInitialCoManagerState, fetchInitialState, fetchOnboardingForm, updateEmployeeDetails } from './employeeDetailsSlice';
import Loader from '../../components/loader';
import { StepHeading, StepShell } from '../../components/optionCard';
import { fetchInitialState as fetchManagerState } from '../1_ManagerDetails/managerDetailsSlice';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ManagerInfo from '../../components/managerInfo';
import CoManagerSection from '../../components/coManagerInfo';
import EmployeeInfoModal from '../../components/employeeInfoModal';
import EmployeeSection from '../../components/employeeInfo';


const EmployeeDetails = () => {
    const dispatch = useDispatch();
    const employeeDetailsState = useSelector(state => state.employees);
    const manager = useSelector(state => state.manager)
    // The team type answered while generating the link decides which roles can be added
    const linkMeta = useSelector(state => state.navigator.linkMeta);

    const [isEmployeeModalOpen, setIsEmployeeModalOpen] = useState(false);
    const [employeeEditIndex, setEmployeeEditIndex] = useState(null);
    

    useEffect(() => {
        dispatch(fetchInitialState());
        dispatch(fetchManagerState());
        dispatch(fetchInitialCoManagerState())
        if (employeeDetailsState.onboardingForm.length === 0) {
            dispatch(fetchOnboardingForm());
        }        
    },[dispatch, employeeDetailsState.onboardingForm.length])
    
    const handleAddEmployeeButton = () => {
        setEmployeeEditIndex(null); // Reset edit index for adding a new employee
        setIsEmployeeModalOpen(true);
    };

    const handleEditEmployee = (index) => {
        setEmployeeEditIndex(index);
        setIsEmployeeModalOpen(true);
    };

    const handleDeleteEmployee = (index) => {
        const employeeToDelete = employeeDetailsState.data[index];
        dispatch(deleteEmployeeDetails(employeeToDelete)).then(() => {
            toast.success('Employee deleted successfully!');
        });
    };


    const handleAddorUpdateEmployee = (employeeData) => { 
        if (employeeEditIndex !== null) {
            // Edit existing employee
            dispatch(updateEmployeeDetails(employeeData)).then(() => {
                toast.success('Employee updated successfully!');
            });
        } else {
            // Add new employee
            dispatch(SubmitEmployeeDetails(employeeData)).then(() => {
                toast.success('Employee added successfully!');
            });
        }
        setEmployeeEditIndex(null); // Reset edit index
        setIsEmployeeModalOpen(false); // Close modal
    }


    return (
        <>
            { employeeDetailsState.loading && <Loader />}
            <StepShell>
                <StepHeading>
                    Now lets add the rest of your Team
                </StepHeading>
            </StepShell>

            {/* Help Note */}
            <div className='mt-6 flex justify-center px-1 text-center'>
                <p className="rounded-xl bg-orange-50 px-4 py-2.5 text-sm font-semibold text-[#211b4f] ring-1 ring-inset ring-orange-200">
                    <span className="text-red-600">Note: </span>
                    If you don’t want to add any more employees, please scroll to the bottom and hit next.
                </p>
            </div>

            <div className='mx-auto w-full max-w-4xl px-1'>
                {/* Add Manager Info */}
                <ManagerInfo
                    data={manager.data}
                />

                {/* Add Co Manager Info */}
                {employeeDetailsState?.co_managers && <CoManagerSection 
                    data={employeeDetailsState?.co_managers || []} 
                />}
                
                {/* Add Employee Info */}
                <EmployeeSection 
                    data={employeeDetailsState.data}
                    handleEdit={handleEditEmployee}
                    handleDelete={handleDeleteEmployee}
                    handleAddEmployeeButton={handleAddEmployeeButton}
                />
            </div>
            
            {/* Toast Notification handled globally in App.js */}

            {/* Manager Info Modal */}
            {/* <ManagerInfoModal
                isOpen={isManagerModalOpen}
                onboardingForm={employeeDetailsState.onboardingForm}
                onSave={(data1) => console.log(data1)}
                handleModalClose={() => setIsManagerModalOpen(false)}
                managerData={manager.data} 
            /> */}

            {/* Co Manager Info Modal */}
            {/* <CoManagerInfoModal
                isOpen={isCoManagerModalOpen}
                onboardingForm={employeeDetailsState.onboardingForm}
                onSave={handleAddorUpdateCoManager}
                handleModalClose={() => setIsCoManagerModalOpen(false)}
                coManagerData={coManagerEditIndex !== null ? employeeDetailsState.co_managers[coManagerEditIndex] : null}
                index={coManagerEditIndex}
            /> */}

            {/* Employee Info Modal */}
            <EmployeeInfoModal
                isOpen={isEmployeeModalOpen}
                onboardingForm={employeeDetailsState.onboardingForm}
                onSave={handleAddorUpdateEmployee}
                handleModalClose={() => setIsEmployeeModalOpen(false)}
                flowType={linkMeta?.newType}
                employeeData={employeeEditIndex !== null ? employeeDetailsState.data[employeeEditIndex] : null}
                index={employeeEditIndex}
            />
        </>

    )
}

export default EmployeeDetails;